import { Component, Input } from '@angular/core';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { keyedStatusOptions } from 'app/core/options/provider-office-status.opts';

import { RouterLinkActive, RouterLink } from '@angular/router';
import { CopyToClipboardComponent } from '../../../shared/components/copy-to-clipboard/copy-to-clipboard.component';
import { ProviderOfficeFaxStatusComponent } from '../provider-office-fax-status/provider-office-fax-status.component';
import { NotesForModelComponent } from '../../../shared/components/notes-for-model/notes-for-model.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-office-provider-list',
    templateUrl: './office-provider-list.component.html',
    styleUrls: ['./office-provider-list.component.scss'],
    imports: [RouterLinkActive,
              RouterLink,
              CopyToClipboardComponent,
              ProviderOfficeFaxStatusComponent,
              NotesForModelComponent,
              MatProgressSpinner]
})
export class OfficeProviderListComponent {
  @Input() providerOffices: ProviderOffice[];
  @Input() loading: boolean;

  keyedStatusOptions = keyedStatusOptions;
}
